module.exports = __webpack_public_path__ + "0.1.2/img/mean-collectMoney.7babb0b6.jpeg";